import {useState} from "react";
import NavBar from "./NavBar";
import {Button, Input} from "antd";
import {addDoc, collection, getDoc, setDoc, doc} from "firebase/firestore";
import {db, auth, storage} from "../base";
import {z} from "zod";
import {useQueryClient} from "@tanstack/react-query";

function GeneraCodiceSconto() {
    const [codice, setCodice] = useState(false);
    const [loading, setloading] = useState(false);
    const [valore, setValore] = useState("");

    const queryClient = useQueryClient()

    async function generaCodice() {
        function randomString(length, chars) {
            var result = "";
            for (var i = length; i > 0; --i)
                result += chars[Math.floor(Math.random() * chars.length)];
            return result;
        }

        var rString = randomString(8, "123456789ABCDEFGHJKLMNPQRSTUVWXYZ");

        const docRef = doc(db, "codiciSconto", rString);
        const docSnap = await getDoc(docRef);
        const puntiInNumber = z.coerce.number().parse(valore)

        if (docSnap.exists()) {
            return;
        }

        await setDoc(doc(db, "codiciSconto", rString), {
            punti: puntiInNumber,
            creazione: new Date(),
        });
        setCodice(rString);
        await queryClient.invalidateQueries({queryKey: ['gift-cards']})
    }

    if (loading) return <div></div>;

    return (
        <div>

                {codice ? (
                    <div
                        style={{
                            textAlign: "center",
                            border: "1px solid grey",
                            borderRadius: 20,
                            padding: 20,
                        }}
                    >
                        <h2>Il codice è:</h2>
                        <h1 style={{marginBottom: 40}}>{codice}</h1>
                        <Button
                            onClick={() => {
                                setCodice(false);
                                setValore("");
                            }}
                            type="primary"
                        >
                            Genera nuovo codice
                        </Button>
                    </div>
                ) : (
                    <div style={{padding: 10, background: '#f7f7f7', borderRadius: 10, marginBottom: 20}}>
                        <h2>Nuova Gift Card</h2>
                        <div style={{display: 'flex', gap: 10, marginBottom: 20}}>
                            <Input
                                style={{ width: "100%" }}
                                value={valore}
                                onChange={(e) => setValore(e.target.value)}
                                size="large"
                                type="number"
                                placeholder="Valore codice sconto"
                            />
                            <Button
                                disabled={!valore}
                                onClick={() => generaCodice()}
                                size="large"
                                type="primary"
                            >
                                Genera codice
                            </Button>
                        </div>
                    </div>
                )}
        </div>
    );
}

export default GeneraCodiceSconto;
